module.exports = __webpack_public_path__ + "static/img/logo_impoBachillerato.0acce69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo_impoBachillerato.png
// module id = rhoO
// module chunks = 232